import React from 'react';
import { Route } from 'react-router-dom';
import AllowRole from 'src/components/AllowRole';
import OrganizationsPage from 'src/pages/administration/OrganizationsPage';
import OrganizationPage from 'src/pages/administration/OrganizationPage';

import PartnersPage from 'src/pages/administration/PartnersPage';

export default function AdministrationRoutes() {
	return (
		<>
			<Route
				path="/administracao"
				element={<AllowRole role={'admin'} />}
			>
				<Route
					path="organizacao"
					element={<OrganizationPage />}
				/>
				<Route
					path="organizacoes"
					element={<AllowRole role={'partner'} />}
				>
					<Route
						path=""
						element={<OrganizationsPage />}
					/>
				</Route>
				<Route
					path="parceiros"
					element={<AllowRole role={'super_admin'} />}
				>
					<Route
						path=''
						element={<PartnersPage />}
					/>
				</Route>
			</Route>
		</>
	);
}
